import styled from "@emotion/styled"
import { Button, FormControl, InputLabel, Select } from "@mui/material"
import { sharedColors } from "ui/theme/colors"

export const InputsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
  }
`

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 32px;
    padding-top: 24px;
  }
`

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 352px;
    margin-top: -8px;
  }
`

export const StyledInputLabel = styled(InputLabel)`
  &[data-shrink="true"] {
    transform: translate(14px, 0px) scale(0.75);
  }
`
export const CheckboxRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  grid-column: 1 / -1;
`

export const StyledDivider = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.up("md")} {
    display: block;
    width: 1px;
    height: 24px;
    background-color: ${sharedColors.borderGray};
  }
`

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    align-items: center;
    flex-direction: row;
    gap: 16px;
  }
`

export const StyledButton = styled(Button)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 300px;
  }
`

export const StyledSelect = styled(Select)`
  height: 56px !important;
  & .MuiSelect-select {
    display: flex;
    align-items: flex-end;
  }
  & .MuiOutlinedInput-input {
    padding: 12px !important;
  }
`

export const StyledSelectMenuProps = {
  anchorOrigin: {
    vertical: "bottom" as const,
    horizontal: "left" as const,
  },
  transformOrigin: {
    vertical: "top" as const,
    horizontal: "left" as const,
  },
  PaperProps: {
    style: {
      marginTop: "1px",
      borderRadius: "0 0 12px 12px",
    },
    sx: {
      height: "300px",
      overflowY: "auto",
      outline: `1px solid ${sharedColors.labelGray}`,
      "::-webkit-scrollbar": {
        width: "8px",
      },
      "::-webkit-scrollbar-thumb": {
        height: "50px",
        borderRadius: "200px",
        width: "8px",
      },
      scrollbarColor: "#D1D5DB transparent",
      "& .MuiMenuItem-root": {
        padding: "16px",
      },
    },
  },
}
